





































































































































































import Vue from 'vue';
import { mapState } from 'vuex';
import hotsitesServices from '@/services/hub/hotsites';
import {
  HubButton,
  HubCard,
  HubCheckbox,
  HubIcon,
  HubMenu,
  HubModal,
} from '@/components/HubComponents';
import Helpers from '@/utils/Helpers';

export default Vue.extend({
  name: 'HotsitesTable',

  components: {
    HubButton,
    HubCard,
    HubCheckbox,
    HubIcon,
    HubMenu,
    HubModal,
  },

  props: {
    data: {
      type: Array as () => Views.ViewHotsites.Hotsite[],
      required: true,
    },
  },

  data() {
    return {
      confirmButtonIsLoading: false,
      copySuccess: false,

      dotsMenuItems: ['copy_iframe', 'delete', 'edit', 'edit_layout', 'visualize'],

      hotsites: [] as Views.ViewHotsites.Hotsite[],
      hotsiteToBeDeleted: {} as Views.ViewHotsites.Hotsite,

      modalConfirmDeletion: false,

      orderType: 'DESC' as 'ASC' | 'DESC',

      selectAll: false,

      hotsiteTypes: {
        WebTV: '',
        Gallery: '',
      },
    };
  },

  computed: {
    ...mapState(['user']),
    selectedHotsites(): Views.ViewHotsites.Hotsite[] {
      return this.hotsites.filter((hotsite) => hotsite.selected);
    },
    userState(): Store.User.State {
      return this.user;
    },
  },

  watch: {
    data() {
      this.hotsites = this.data;
    },
    selectedHotsites() {
      this.selectAll = this.selectedHotsites.length === this.hotsites.length;
    },
  },

  async mounted() {
    this.hotsites = this.data;
  },

  methods: {
    async deleteHotsite(
      payload: Services.Hotsites.DeleteHotsite,
      showNotification = true,
    ): Promise<void> {
      return hotsitesServices.deleteHotsite(payload)
        .then(() => {
          if (showNotification) this.showNotification('channel_deleted_successfully', 'success');
        })
        .catch((error) => {
          console.error('HotsitesTable - method: "deleteHotsite()" ', error);

          if (showNotification) this.showNotification('error_deleting_channel', 'error');

          throw new Error(error);
        });
    },
    onClickCopyIframe(hotsite: Views.ViewHotsites.Hotsite): void {
      const iframeCode = String.prototype.concat(
        '<iframe',
        ' frameborder="0"',
        ' height="300"',
        ` src="${hotsite.linkToHotsitePage}/Gallery"`,
        ' width="500"',
        '></iframe>',
      );

      Helpers.copyToClipboard(iframeCode)
        .then(() => {
          const index = this.hotsites.findIndex((h) => h.id === hotsite.id);

          Vue.set(this.hotsites[index], 'copySuccess', true);

          setTimeout(() => {
            Vue.set(this.hotsites[index], 'copySuccess', false);
          }, 1500);
        })
        .catch(() => { /**/ });
    },
    onClickCreatedOn(): void {
      this.orderType = this.orderType === 'ASC' ? 'DESC' : 'ASC';

      this.$emit('changeOrderType', this.orderType);
    },
    onClickDelete(hotsite: Views.ViewHotsites.Hotsite, showModal = true) {
      if (showModal) {
        this.hotsiteToBeDeleted = hotsite;
        this.modalConfirmDeletion = true;

        return;
      }

      this.confirmButtonIsLoading = true;

      this.deleteHotsite({ hotsiteIds: [hotsite.id], planId: parseInt(this.userState.planId, 10) })
        .then(() => {
          this.modalConfirmDeletion = false;

          this.$emit('getHotsites');
        })
        .catch(() => { /**/ });

      this.confirmButtonIsLoading = false;
    },
    onClickDeleteSelected(): void {
      this.deleteHotsite(
        {
          hotsiteIds: this.selectedHotsites.map((hotsite) => hotsite.id),
          planId: parseInt(this.userState.planId, 10),
        },
        false,
      )
        .then(() => {
          this.modalConfirmDeletion = false;

          if (this.selectedHotsites.length > 1) {
            this.showNotification('channels_deleted_successfully', 'success');
          } else {
            this.showNotification('channel_deleted_successfully', 'success');
          }

          this.$emit('getHotsites');
        })
        .catch(() => {
          if (this.selectedHotsites.length > 1) {
            this.showNotification('error_deleting_channels', 'error');
          } else {
            this.showNotification('error_deleting_channel', 'error');
          }
        });
    },
    onClickEdit(hotsite: Views.ViewHotsites.Hotsite): void {
      this.$emit('clickEdit', hotsite);
    },
    onClickEditLayout(hotsite: Views.ViewHotsites.Hotsite): void {
      this.$emit('clickEditLayout', hotsite);
    },
    onClickOnDotsMenuItem(
      item: 'copy_iframe' | 'delete' | 'edit' | 'edit_layout' | 'visualize',
      hotsite: Views.ViewHotsites.Hotsite,
    ): void {
      switch (item) {
        case 'copy_iframe': this.onClickCopyIframe(hotsite); break;
        case 'delete': this.onClickDelete(hotsite); break;
        case 'edit': this.onClickEdit(hotsite); break;
        case 'edit_layout': this.onClickEditLayout(hotsite); break;
        case 'visualize': this.onClickVisualize(hotsite); break;
        default: break;
      }
    },
    onClickVisualize(hotsite: Views.ViewHotsites.Hotsite): void {
      if (hotsite.hotsite_type !== 'WebTV') {
        window.open(`${hotsite.linkToHotsitePage}/${hotsite.hotsite_type}`, '_blank');
      } else {
        window.open(`${hotsite.linkToHotsitePage}/channel`, '_blank');
      }
    },
    onClickSelectAll(): void {
      Vue.set(
        this,
        'hotsites',
        this.hotsites.map((hotsite) => ({ ...hotsite, selected: !this.selectAll })),
      );

      this.selectAll = !this.selectAll;
    },
    showNotification(text: string, type: 'error' | 'success'): void {
      this.$store.dispatch('notification/create', { text, type });
    },
  },
});
